import styled from "styled-components";

export const StyledTick = styled.svg.attrs({
  viewBox: "0 0 13 11",
  fill: "none",
})`
  width: 13px;
  height: 11px;
`;
